export default "__VITE_ASSET__DBN6GNDi__"